'use strict';

module.exports = require('./Slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-slider/lib/index.js
 ** module id = 720
 ** module chunks = 0
 **/